import { render, staticRenderFns } from "./TabsButton.vue?vue&type=template&id=471d4400"
import script from "./TabsButton.vue?vue&type=script&lang=js"
export * from "./TabsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports